import notice_icon from './img/notice-icon.svg';
import notice_icon_active from './img/notice-icon-active.svg';
import manual_icon from './img/manual_icon.svg';
import manual_icon_active from './img/manual_icon_active.svg';
import calendar_icon from './img/calendar-icon.svg';
import calendar_icon_active from './img/calendar-icon-active.svg';
import profile_icon from './img/user-icon.svg';
import profile_icon_active from './img/user-icon-active.svg';
import duty_icon from './img/duty.svg';
import duty_icon_active from './img/duty-active.svg';
import home_icon from './img/home-icon.svg';
import home_icon_active from './img/home-active.svg';
import { twJoin } from 'tailwind-merge';
import { useTranslation, withTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { DefaultSystemBrowserOptions, InAppBrowser, DefaultWebViewOptions } from "@capacitor/inappbrowser";
export const button_navigation = [
    {
        link: 'roaster',
        text: 'duty',
        icon: duty_icon,
        activeicon: duty_icon_active
    },
    {
        link: '/profile/manuals',
        text: 'manual',
        icon: manual_icon,
        activeicon: manual_icon_active
    },
    {
        link: '/home',
        text: 'home',
        icon: home_icon,
        activeicon: home_icon_active
    },
    {
        link: '/profile/notice_board',
        text: 'notice',
        icon: notice_icon,
        activeicon: notice_icon_active
    },
    // {
    //     link: '/profile/calendar',
    //     text: 'calendar',
    //     icon: calendar_icon,
    //     activeicon: calendar_icon_active
    // },
    {
        link: '/profile',
        // link2:'/profile/notice_board',
        text: 'profile',
        icon: profile_icon,
        activeicon: profile_icon_active
    },
];
export const goToRoaster = async () => {
    const user_data=localStorage.getItem('userData');
    let employee_id='';
    if(user_data){
        const user_info=JSON.parse(user_data);
        employee_id=user_info?.user?.employee?.employeeID
    }
    await InAppBrowser.openInSystemBrowser({
      url: `https://rms.satshk.com/#/sso-landing?employeeNo=${employee_id}&baseKey=U0FUUy1TU086NjdhMzQ3MTY0NWE1NDY0ZTgyZjZiNjZlMzE1NzFiYzY=`, 
      options: DefaultSystemBrowserOptions
    }).then((res) => {
      const url = window.location;
      console.log("res", res, url)
    });
  }
const FixedBottomNavigation = (props: any) => {
    const navigate = useNavigate();
    const {t}=useTranslation();
    return <div className='w-full flex justify-center bottom_navigation fixed left-0 bottom-0 bottom-navigation bg-white'>
        <div className='py-3 bg-white flex justify-around items-center w-full max-w-[360px]'>
            {button_navigation?.map((nav, key) => {
                let active = 'inactive';
                if ((window.location.pathname == nav.link)) {
                    active = 'active'
                }
                if (window.location.pathname == '/profile/notice_board1') {
                    navigate('/profile/notice_board')
                }
                if (nav.link !== "roaster") {
                    return <NavLink to={{ pathname: nav.link }}
                        className={twJoin(active, 'inline-block')}
                        key={key}>
                        <img src={active == 'active' ? nav.activeicon : nav.icon} alt={"button icon " + key} className='mx-auto' />
                        <p className='text-[10.75px] text-center text-sat_darkblackv2 mt-1'>{t(nav.text)}</p>
                    </NavLink>
                }else{
                    return <button className="inline-block" onClick={() => goToRoaster()}>
                        <img src={active == 'active' ? nav.activeicon : nav.icon} alt={"button icon " + key} className='mx-auto' />
                        <p className='text-[10.75px] text-center text-sat_darkblackv2 mt-1'>{t(nav.text)}</p>
                    </button>
                }

            })
            }
        </div>
    </div>
}
export default withTranslation('common')(FixedBottomNavigation);